import Vue from 'vue'

export default {
  by(object) {
    if (object.has_avatar) {
      return `${Vue.config.modules.crm.storage}${object.employer_avatar}`
    } else {
      return ''
    }
  },
}
